import { Observable } from 'rxjs/Observable';
import { IIdCard, IIdCardsResponse } from '../../../api/plans/plans.interfaces';
import { IPlanCoverage } from '../../../api/profile/profile.interfaces';
import { ICarouselController } from '../../../ui/carousel/carousel.interfaces';

export interface ICoverageSection extends IPlanCoverage {
  cards: IIdCard[];
  flipped: boolean;
  idCardsRequest: Observable<IIdCardsResponse>;
  planName: string;
  planType: string;
  template: string;
  selectedDepSeqNum?: string;
  showGroupNumber?: boolean;
  showCarveOutLink?: boolean;
  $carousel?: ICarouselController;
}

export const IPlanTypes = {
  MEDICAL: 'MEDICAL_PLAN',
  VISION: 'VISION_PLAN',
  DENTAL: 'DENTAL_PLAN',
  BEHAVIORAL_HEALTH: 'BH_PLAN',
  RX: 'DRUG_PLAN',
};

export enum CardSide {
  Front = 'view-front',
  Back = 'view-back',
}

export interface IIdCardsStateParams extends ng.ui.IStateParamsService {
  flipped?: boolean;
}
